// extracted by mini-css-extract-plugin
module.exports = {"entity":"entity___DyOHH","toggler":"toggler___2bgkR","label":"label___3zL4H","infos":"infos___RjEho","color-picker-field":"color-picker-field___U0Fa9"};